import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { ClientBackgroundColorChange as BackgroundColorChange } from "~/components/bloks/ArticlePageBlok/ClientBackgroundColorChange";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { ArticleStoryblok } from "~/generated/sb/blok-types";
import styles from "./ArticlePageBlok.module.css";

export const ArticlePageBlok = ({ blok, preview }: BlokProps<ArticleStoryblok>) => {
	const Title = () =>
		!blok?.Title ? null : (
			<h1 className={clsx(styles.hero__heading, "blok-big-title")}>{blok.Title}</h1>
		);
	const Subtitle = () =>
		!blok?.shortDescription ? null : (
			<h2 className={clsx("blok-subtitle", styles.hero__subtitle)}>{blok.shortDescription}</h2>
		);

	const MainImageBlok = () =>
		!blok.mainImage ? null : (
			<div data-layout="blok" className={styles.mainImage}>
				<StoryblokComponent blok={blok.mainImage[0]} preview={preview} />
			</div>
		);

	return (
		<BlokWrap as="main" key={blok._uid} editable={blok} className="article-page">
			<BackgroundColorChange
				color={
					typeof blok.backgroundColor === "number"
						? `#${blok.backgroundColor}`
						: (blok.backgroundColor ?? "var(--color-background)")
				}
			/>
			<div data-layout="blok" className={styles.hero}>
				<Title />
				<Subtitle />
			</div>

			<MainImageBlok />

			{blok.content?.map((currentBlok) => (
				<StoryblokComponent
					blok={currentBlok}
					key={`current-blok--${currentBlok._uid}`}
					preview={preview}
				/>
			))}
		</BlokWrap>
	);
};
